import toast from "react-hot-toast";
import { accountService } from "./accountServices";
import { useNavigate } from "react-router-dom";

const navigate = useNavigate;

export function catchErrorApiCall(err) {
  // console.log(err);
  if (err.code === "ERR_NETWORK") {
    return toast.error("Connexion impossible, réessayer plus tard");
  } else if (err.response.status === 403) {
    toast.error("Votre session a expiré, veuillez vous reconnectez", {
      style: {
        backgroundColor: "#630f0f", // Custom background color
        color: "white", // Text color
        fontSize: "12px", // Font size
        zIndex: 99999,
      },
    });
    // window.location.reload();
    accountService.logout();
    return navigate("/", { replace: true });
  } else if (err.response.status === 401) {
    toast.error("Vérifiez qu'il y a pas un doublon, ensuite réessayez", {
      style: {
        backgroundColor: "#630f0f", // Custom background color
        color: "white", // Text color
        fontSize: "12px", // Font size
        zIndex: 99999,
      },
    });
  } else {
    return toast.error("Une erreur s'est produite, réesayez plus tard", {
      style: {
        backgroundColor: "#630f0f", // Custom background color
        color: "white", // Text color
        fontSize: "12px", // Font size
        zIndex: 99999,
      },
    });
  }
}
